import cx from '@vindr/utils/helpers/cx';
import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { Suspense } from 'react';
import TransitionPage from '../TransitionPage';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import { Outlet } from 'react-router-dom';

interface SiderLayoutProps {
  sidebar?: React.ReactNode;
  rightSidebar?: React.ReactNode;
  children?: React.ReactNode;
  className?: Parameters<typeof cx>['0'];
}

const SiderLayout = ({ sidebar, rightSidebar = null, children, className }: SiderLayoutProps) => {
  return (
    <Layout hasSider className={cx('bg-[#1F2C33]', className)} style={{ height: `100%` }}>
      {sidebar}
      <Content>
        {children || (
          <Suspense fallback={<></>}>
            <TransitionPage fade={false} className="h-full" timeout={150}>
              <Outlet />
            </TransitionPage>
          </Suspense>
        )}
      </Content>
      {rightSidebar}
    </Layout>
  );
};

export default SiderLayout;
